<app-navigation></app-navigation>
<div *ngIf="christmas" class="snowflakes" aria-hidden="true">
  <div *ngFor="let item of [].constructor(12)" class="snowflake">❅</div>
</div>
<div id="backgroundImage">
  <div id="cotraContainer" class="container">
    <div id="headerContainer" class="row unselectable headline strong">
      <div>{{translation?.LoginHeaderTitleLine1}}</div>
      <div>{{translation?.LoginHeaderTitleLine2}}</div>
    </div>
    <div id="loginContainer" class="row justify-content-center">
      <div class="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-4">
        <form id="loginForm">
          <div class="loginItem unselectable subhead">{{translation?.Login}}</div>
          <mat-form-field class="loginItem">
            <input matInput placeholder="{{translation?.User}}" (keyup.enter)="login()" [(ngModel)]="username" type="text" name="username" required>
          </mat-form-field>
          <mat-form-field class="loginItem">
            <input matInput placeholder="{{translation?.Password}}" (keyup.enter)="login()" [(ngModel)]="password" type="password" name="password" required>
          </mat-form-field>
          <div id="loginButton" class="loginItem subhead whiteText unselectable" (keyup.enter)="login()" (click)="login()">Login</div>
        </form>
        <p id="getLoginLink" class="upperCase unselectable" (click)="openContactForm(translation.LoginRequest)">{{translation.RequestLogin}}</p>
        <p id="forgotPasswordLink" class="upperCase unselectable" (click)="openResetPasswordForm()">{{translation.ForgotPassword}}?</p>
        <ng-template #callDialog>
          <div style="display: flex; flex-direction: column; min-width: 450px;">
            <h2 matDialogTitle>{{newContactMessage.Title}}</h2>
            <mat-form-field class="fieldForm">
              <input matInput name="title" type="text" required="required" placeholder="{{translation.Subject}}" [(ngModel)]="newContactMessage.Title">
            </mat-form-field>
            <div class="fieldFormShortContainer">
              <mat-form-field class="fieldFormShort">
                <input matInput name="email" type="text" required="required" placeholder="{{translation.Email}}" [(ngModel)]="newContactMessage.Email">
              </mat-form-field>
              <mat-form-field class="fieldFormShort">
                <input matInput name="phone" type="text" required="required" placeholder="{{translation.Phone}}" [(ngModel)]="newContactMessage.Phone">
              </mat-form-field>
            </div>
            <div class="fieldFormShortContainer">
              <mat-form-field class="fieldFormShort">
                <input matInput name="firstName" type="text" required="required" placeholder="{{translation.FirstName}}" [(ngModel)]="newContactMessage.FirstName">
              </mat-form-field>
              <mat-form-field class="fieldFormShort">
                <input matInput name="lastName" type="text" required="required" placeholder="{{translation.LastName}}" [(ngModel)]="newContactMessage.LastName">
              </mat-form-field>
            </div>
            <div class="fieldFormShortContainer">
              <mat-form-field class="fieldFormShort">
                <input matInput name="company" type="text" required="required" placeholder="{{translation.Company}}" [(ngModel)]="newContactMessage.Company">
              </mat-form-field>
              <mat-form-field class="fieldFormShort">
                <input matInput name="street" type="text" required="required" placeholder="{{translation.Street}}" [(ngModel)]="newContactMessage.Street">
              </mat-form-field>
            </div>
            <div class="fieldFormShortContainer">
              <mat-form-field class="fieldFormShort">
                <input matInput name="zip" type="text" required="required" placeholder="{{translation.Zip}}" [(ngModel)]="newContactMessage.Zip">
              </mat-form-field>
              <mat-form-field class="fieldFormShort">
                <input matInput name="city" type="text" required="required" placeholder="{{translation.City}}" [(ngModel)]="newContactMessage.City">
              </mat-form-field>
            </div>
            <p style="font-weight: bold">{{translation.DesiredModules}}:</p>
            <div class="checkBoxContent">
              <mat-checkbox color="primary" class="contactMessageCheckbox" [(ngModel)]="newContactMessage.Transport">{{translation.Transport}}</mat-checkbox>
              <mat-checkbox color="primary" class="contactMessageCheckbox" [(ngModel)]="newContactMessage.DamageReport">{{translation.DamageReport}}</mat-checkbox>
              <mat-checkbox color="primary" class="contactMessageCheckbox" [(ngModel)]="newContactMessage.WheelNews">{{translation.WheelNews}}</mat-checkbox>
              <mat-checkbox color="primary" class="contactMessageCheckbox" [(ngModel)]="newContactMessage.Fotobox">{{translation.Fotobox}}</mat-checkbox>
            </div>
            <mat-form-field class="fieldForm">
              <textarea matInput name="message" type="text" required="required" placeholder="{{translation.Message}}" [(ngModel)]="newContactMessage.Message" rows="5"></textarea>
            </mat-form-field>
            <mat-dialog-actions align="end">
              <button mat-button class="customButton" (click)="cancel()">{{translation.Cancel}}</button>
              <button mat-button class="customButton" (click)="send()">{{translation.Send}}</button>
            </mat-dialog-actions>
          </div>
        </ng-template>
        <ng-template #callPasswordDialog>
          <div style="display: flex; flex-direction: column; min-width: 450px;">
            <h2 matDialogTitle>{{translation.ForgotPassword}}</h2>
            <p>{{translation.PleaseEnterYourEmail}}</p>
            <mat-form-field class="fieldForm">
              <input matInput name="email" type="text" required="required" placeholder="{{translation.Email}}" [(ngModel)]="email">
            </mat-form-field>
            <mat-dialog-actions align="end">
              <button mat-button class="customButton" (click)="cancel()">{{translation.Cancel}}</button>
              <button mat-button class="customButton" (click)="changePassword()">{{translation.Send}}</button>
            </mat-dialog-actions>
          </div>
        </ng-template>
      </div>
    </div>
    <app-logos-with-link id="logoContainer"></app-logos-with-link>
  </div>
</div>
<footer class="unselectable">
  <div id="footer" class="container">
    <div class="row justify-content-center smallerText">
      <div>&nbsp;© 2020 COTRA AUTOTRANSPORT AG&nbsp;</div>
      <div>&nbsp;|&nbsp;</div>
      <a class="links upperCase" (click)="openContactForm('')">{{translation?.Contact}}</a>
      <div>&nbsp;|&nbsp;</div>
      <a class="links upperCase" href="#">{{translation?.Impressum}}</a>
    </div>
  </div>
</footer>
